import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ALPHA, BETA } from '../../../common/utils/environments';
import showAlert from '../../../common/utils/alert';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';
import { WithContext as ReactTags } from 'react-tag-input';
import { useFormik } from 'formik';
import { validateIp, validateIPAddress } from '../../../common/utils/validate';

const KeyCodes = {
  comma: 188,
  enter: 13,
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];
const EnvSetting = ({ projectId, version, environment, projectDetail, deleteFlag, actions }) => {
  const [copied, setCopied] = useState('');
  const [ipTags, setIpTags] = useState([]);
  const { value, icon } = environment;
  const { environments, projectType } = projectDetail;
  const getDataFromEnv = (value, env) => {
    let result = '';
    environments.find((obj) => {
      if (obj.envType === env) {
        result = obj[value];
      }
    });
    return result;
  };

  const copyToClipboard = (env) => {
    setCopied(env);
    setTimeout(() => {
      setCopied('');
    }, 2000);
  };

  const key = getDataFromEnv('key', value);
  const uuid = getDataFromEnv('uuid', value);
  const disabled = ['FREE', 'PAID_1'].includes(projectType) && [ALPHA, BETA].includes(value);

  useEffect(() => {
    const envData = environments.find((env) => env.uuid === uuid);
    if (envData) {
      const ipAddresses = envData.ipAddresses
        ? envData.ipAddresses.map((ip) => ({ id: ip, text: ip }))
        : [];
      setIpTags(ipAddresses);
    }
  }, []);

  const handleRemoveTag = (i) => {
    const ip = ipTags[i].text;
    const newTags = ipTags.filter((tag, index) => index !== i);
    setIpTags(newTags);
  };

  const handleAddition = (tag) => {
    if (validateIp(tag.text)) {
      setIpTags([...ipTags, tag]);
      formik.setFieldError('ipAddress', '');
    } else {
      formik.setFieldError('ipAddress', 'Invalid IP address');
    }
  };

  const handleUpdate = async () => {
    const ipAddresses = ipTags.map((tag) => tag.text);
    await actions.updateIpAddresses({ ipAddresses, uuid, projectId, version });
  };

  const handleCreate = () => {
    if (key) {
      takeAction('create', uuid);
    } else {
      actions.updateDevKey({ action: 'create', version, projectId, uuid });
    }
  };

  const handleDelete = () => {
    if (deleteFlag) {
      takeAction('delete', uuid);
    }
  };

  const takeAction = (action, uuid) => {
    let text = '';
    let confirmButtonText = '';
    let msg = '';

    if (action === 'delete') {
      text = "You won't be able to revert it!";
      confirmButtonText = 'Yes, delete it';
      msg = 'Deleted Successfully!';
    } else if (action === 'create') {
      text = 'Creating New Key will replace existing Key';
      confirmButtonText = 'Yes, create new key!';
      msg = 'Created Successfully!';
    }

    const preConfirm = () => {
      return actions.updateDevKey({ action, version, projectId, uuid, msg });
    };

    showAlert(text, preConfirm, confirmButtonText);
  };

  const formik = useFormik({
    initialValues: {
      ipAddress: '',
    },
    validationSchema: validateIPAddress(),
    onSubmit: (values, { resetForm }) => {
      const ipAddresses = values.ipAddress
        .split(',')
        .map((ip) => ({ id: ip.trim(), text: ip.trim() }));
      setIpTags([...ipTags, ...ipAddresses]);
      resetForm();
    },
  });
  return (
    <>
      <div className="row">
        <div className="col-md-2 col-lg-2 col-sm-2 pt-4 my-2">
          <b>API Key</b>
        </div>
        <div className="col-md-7 col-lg-7 col-sm-7 py-2 my-2">
          <div className="p-3 bg-light border border-light rounded d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div>{key ? key : 'No Key Found, Create New Key'}</div>&nbsp;&nbsp;
              {copied === value ? <div className="text-secondary">Copied</div> : ''}
            </div>
            <CopyToClipboard
              style={{ cursor: 'pointer' }}
              text={key ? key : ''}
              onCopy={() => {
                if (key) {
                  copyToClipboard(value);
                }
              }}
            >
              <i className="webconnect webconnect-files" />
            </CopyToClipboard>
          </div>
        </div>
        <div className="col-md-3 col-lg-3 col-sm-3 py-2 my-2 row">
          <div className="col-md-8 col-lg-8 col-sm-8">
            <button className="btn btn-theme-submit" onClick={handleCreate} disabled={disabled}>
              <i className="webconnect webconnect-refresh" />
            </button>
            <button
              className="btn btn-theme-delete"
              style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
              title="Delete Key"
              onClick={handleDelete}
              disabled={disabled}
            >
              <i className="wb webconnect-trash-regular" />
              {deleteFlag ? null : (
                <TooltipInfo
                  title={description}
                  headerText="Permission Disabled!"
                  showHeader={true}
                  showArrow={true}
                />
              )}
            </button>
          </div>
        </div>
      </div>
      {/* <div className="row">
        <div className="col-md-2 col-lg-2 col-sm-2 pt-4 my-2">
          &nbsp;
          <b>IP Addresses</b>
        </div>
        <div className="col-md-7 col-lg-7 col-sm-7 py-2 my-2">
          <ReactTags
            tags={ipTags}
            handleDelete={handleRemoveTag}
            handleAddition={handleAddition}
            delimiters={delimiters}
            autocomplete
            placeholder="e.g., 0.0.0.0 , 0.0.1.0"
          />
          {formik.errors.ipAddress ? (
            <div className="text-danger">{formik.errors.ipAddress}</div>
          ) : null}
          <small className="field-detail">
            Press [ Enter ⏎ ] or, [ Comma , ] key to add IP Addresses
          </small>
        </div>
        <div className="col-md-3 col-lg-3 col-sm-3 py-2 my-2 d-flex align-items-center">
          <button className="btn btn-theme-submit" onClick={handleUpdate}>
            <i className="wb webconnect-save-regular" /> Update
          </button>
        </div>
      </div> */}
    </>
  );
};

export default EnvSetting;
